import { createRequestTypes } from '../utils';

export const WORKFLOW_STATUS_LIST = createRequestTypes('workflowStatus/WORKFLOW_STATUS_LIST');
